export default "__VITE_ASSET__CpBU5z6h__"